import React from 'react';
import { Button } from '../ui/Button';
import { Sparkles, BarChart3, Brain, Target } from 'lucide-react';

interface WelcomeStepProps {
  onNext: (data?: any) => void;
  isFirst: boolean;
  isLast: boolean;
}

export function WelcomeStep({ onNext, isFirst, isLast }: WelcomeStepProps) {
  const features = [
    {
      icon: Brain,
      title: 'AI-Powered Insights',
      description: 'Get intelligent analysis of your marketing data with our specialized AI agents'
    },
    {
      icon: BarChart3,
      title: 'Advanced Analytics',
      description: 'Deep dive into your Google Analytics 4 data with powerful visualizations'
    },
    {
      icon: Target,
      title: 'Strategic Recommendations',
      description: 'Receive actionable recommendations to improve your marketing performance'
    }
  ];

  return (
    <div className="text-center space-y-8">
      <div>
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6">
          <Sparkles className="w-10 h-10 text-white" />
        </div>
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Welcome to Crutan AI Marketing Agent
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          Transform your marketing strategy with AI-powered insights and analytics. 
          Let's get you set up to unlock the full potential of your data.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-12">
        {features.map((feature, index) => (
          <div key={index} className="text-center p-6">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg mb-4">
              <feature.icon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{feature.title}</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        <Button onClick={() => onNext()} size="lg" className="w-full md:w-auto">
          Get Started
        </Button>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          This will only take a few minutes to complete
        </p>
      </div>
    </div>
  );
} 